// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { MultiSelectAsync } from 'components/Form'
import Lookup from 'components/Lookup'
import { useSiteContactField } from './hooks'
import { getContactOptions } from '../helpers'

const lookupFormName = 'contact-lookup'

const ContactField = props => {
  const {
    idRoot,
    sourceForm,
  } = props

  const {
    assignSiteContact,
    getLookupTypeProps,
  } = useSiteContactField(sourceForm, lookupFormName)

  return (
    <>
      <Field
        component={MultiSelectAsync}
        id={`${idRoot}contact-codes`}
        label={'Contact Code'}
        labelKey={'contactCode'}
        name={'contactId'}
        optionsResource={getContactOptions}
        sourceForm={sourceForm}
        valueKey={'contactId'} />
      <Lookup
        getLookupTypeProps={getLookupTypeProps}
        lookupFormName={lookupFormName}
        lookupLabel={'Contact Lookup'}
        lookupType={'contact'}
        selectRow={assignSiteContact}
        triggerId={`${idRoot}contact-lookup-trigger`} />
    </>
  )
}

ContactField.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default ContactField
